<template lang="pug">
  .time-wrap
    .env(v-if="showEnv" :class="{'env-with-weather-abs-humidity': this.envInfo.weatherAbsoluteHumidity}")
      .weather-img(:class="weatherCode" :title="weatherText")
      span(title="温度") {{temperature}}°C
      span(title="相对湿度") {{humidity}}%
      span(title="含湿量" v-if="this.envInfo.weatherAbsoluteHumidity") {{weatherAbsoluteHumidity}}g/kg
    i.iconfont.iconbaojing.header-alarm-icon(v-if="alarmNum")
      span.alarm-num {{alarmNum}}
      ul.alarm-ul
        li(v-for="(item, index) in alarmArr" :key="index" :title="item.text" @click="goErrorPage(item)")
          span.alarm-text-inside(:class="[{'alarm-text-inside-warn': item.errorLevel === 'Warning'},{'alarm-text-inside-error': item.errorLevel === 'Error'}]") {{item.text}}
          span.alarm-num-inside {{item.value}}
    span.time-show {{currentTime}}
    el-dropdown
      .date-address-show
        p.address-show {{bridgeName}}
        p.date-show {{currentDate}}
      el-dropdown-menu(slot="dropdown")
        el-dropdown-item(@click.native="logout()") 退出登录
        el-dropdown-item(@click.native="toUserControl()" devided) 用户管理
    p.last-update-time(v-show="lastUpdateTime") {{lastUpdateTime}}
</template>
<script>
import dayjs from 'dayjs'

export default {
  name: 'HeaderTime',
  props: ['bridgeName', 'bridgeId', 'envInfo', 'id2Path'],
  data() {
    return {
      alarmNum: 0,
      showEnv: false,
      weatherText: '',
      temperature: '--',
      humidity: '--',
      weatherAbsoluteHumidity: '--',
      weatherCode: 'bg-100',
      currentTime: '',
      currentDate: '',
      currentTimer: null,
      alarmArr: []
    }
  },
  watch: {
    $route(val) {
      this.$store.commit('resetLastRefreshTime')
    }
  },
  beforeDestroy() {
    this.$store.commit('resetLastRefreshTime')
    clearInterval(this.currentTimer)
  },
  computed: {
    lastUpdateTime() {
      return this.$store.state.lastRefreshTime ? dayjs(this.$store.state.lastRefreshTime).format('HH:mm') : ''
    }
  },
  created() {
    this.updateCurrentTime()
    this.getWarningData()
    this.currentTimer = setInterval(() => {
      this.updateCurrentTime()
      this.getWarningData()
    }, 30000)
  },
  methods: {
    logout() {
      this.$http.post('/auth/Logout').then(() => {
        this.$router.push('/')
      });
    },
    toUserControl() {
      this.$router.push('/admin/userControl');
    },
    /**
     * 更新时间
     */
    updateCurrentTime() {
      this.currentTime = dayjs().format('HH:mm')
      this.currentDate = dayjs().format('MMM DD.YYYY')
    },
    /**
     * 获取警告数据
     */
    getWarningData() {
      if (this.envInfo && this.envInfo.envId && this.envInfo.envId !== "--") {
        this.$http.get('/deviceData/Station?stationId=' + this.envInfo.envId).then(res => {
          this.weatherText = res.data[this.envInfo.weather].enumValue || ''
          this.weatherCode = 'bg-' + res.data[this.envInfo.weather].value || '--'
          this.humidity = res.data[this.envInfo.humidity].value || '--'
          this.temperature = res.data[this.envInfo.temperature].value || '--'
          this.showEnv = true

          if (this.envInfo.weatherAbsoluteHumidity) {
            this.weatherAbsoluteHumidity = res.data[this.envInfo.weatherAbsoluteHumidity].value || '--'
            try {
              if (this.weatherAbsoluteHumidity !== '--') {
                this.weatherAbsoluteHumidity = Number(this.weatherAbsoluteHumidity).toFixed(2);
              }
            }
            catch (ee) {
              console.log("process weather abs humidity failed. ");
            }
          }
        })
      }
      if (this.bridgeId) {
        this.$http.get('/dataError/GlobalError?bridgeId=' + this.bridgeId).then(res => {
          this.alarmNum = res.data.errorDataList.length
          this.alarmArr = res.data.errorDataList.map(el => {
            return {
              text: el.deviceName,
              value: el.value,
              stationId: el.stationId,
              errorLevel: el.errorLevel
            }
          })
        })
      }
    },
    /**
     * 跳转到错误制备站页面
     * @param {Object} item 错误信息
     */
    goErrorPage(item) {
      const target = this.id2Path[item.stationId]
      if (!target) return
      this.$router.push({ path: `/${target}` })
    }
  }
}
</script>

<style lang="scss" scoped>
.time-wrap {
  position: relative;
  width: 240px;
  line-height: 1;
  display: flex;
  justify-content: flex-end;

  .header-alarm-icon {
    display: block;
    font-size: 25px;
    position: relative;
    color: #000;
    margin-right: 10px;
    line-height: 80px;
    height: 60px;
    cursor: pointer;

    .alarm-num {
      font-size: 13px;
      background: #f00;
      position: absolute;
      top: 16px;
      right: -7px;
      width: 17px;
      text-align: center;
      height: 17px;
      border-radius: 50%;
      line-height: 20px;
      color: #fff;
    }

    &:hover .alarm-ul {
      display: block;
    }
  }

  .env {
    width: 100px;
    height: 25px;
    position: absolute;
    left: 13px;
    bottom: -1px;
    align-items: center;
    font-size: 12px;
    display: flex;
    justify-content: flex-start;

    span {
      display: inline-block;
      margin-left: 8px;
    }
  }

  .env-with-weather-abs-humidity{
    width: 145px;
  }

  .weather-img {
    width: 25px;
    height: 25px;
    transform: scale(.8) translateY(0px);
    background-image: url('../assets/image/weather.png');
  }

  .bg-100 {
    background-position: -10px -10px;
  }

  .bg-100n {
    background-position: -55px -10px;
  }

  .bg-101 {
    background-position: -10px -55px;
  }

  .bg-102 {
    background-position: -55px -55px;
  }

  .bg-103 {
    background-position: -100px -10px;
  }

  .bg-103n {
    background-position: -100px -55px;
  }

  .bg-104 {
    background-position: -10px -100px;
  }

  .bg-104n {
    background-position: -55px -100px;
  }

  .bg-200 {
    background-position: -100px -100px;
  }

  .bg-201 {
    background-position: -145px -10px;
  }

  .bg-202 {
    background-position: -145px -55px;
  }

  .bg-203 {
    background-position: -145px -100px;
  }

  .bg-204 {
    background-position: -10px -145px;
  }

  .bg-205 {
    background-position: -55px -145px;
  }

  .bg-206 {
    background-position: -100px -145px;
  }

  .bg-207 {
    background-position: -145px -145px;
  }

  .bg-208 {
    background-position: -190px -10px;
  }

  .bg-209 {
    background-position: -190px -55px;
  }

  .bg-210 {
    background-position: -190px -100px;
  }

  .bg-211 {
    background-position: -190px -145px;
  }

  .bg-212 {
    background-position: -10px -190px;
  }

  .bg-213 {
    background-position: -55px -190px;
  }

  .bg-300 {
    background-position: -100px -190px;
  }

  .bg-301 {
    background-position: -145px -190px;
  }

  .bg-301n {
    background-position: -190px -190px;
  }

  .bg-302 {
    background-position: -235px -10px;
  }

  .bg-300n {
    background-position: -235px -55px;
  }

  .bg-303 {
    background-position: -235px -100px;
  }

  .bg-305 {
    background-position: -235px -145px;
  }

  .bg-304 {
    background-position: -235px -190px;
  }

  .bg-306 {
    background-position: -10px -235px;
  }

  .bg-307 {
    background-position: -55px -235px;
  }

  .bg-309 {
    background-position: -100px -235px;
  }

  .bg-310 {
    background-position: -145px -235px;
  }

  .bg-311 {
    background-position: -190px -235px;
  }

  .bg-312 {
    background-position: -235px -235px;
  }

  .bg-313 {
    background-position: -280px -10px;
  }

  .bg-314 {
    background-position: -280px -55px;
  }

  .bg-315 {
    background-position: -280px -100px;
  }

  .bg-316 {
    background-position: -280px -145px;
  }

  .bg-317 {
    background-position: -280px -190px;
  }

  .bg-318 {
    background-position: -280px -235px;
  }

  .bg-399 {
    background-position: -10px -280px;
  }

  .bg-400 {
    background-position: -55px -280px;
  }

  .bg-402 {
    background-position: -100px -280px;
  }

  .bg-401 {
    background-position: -145px -280px;
  }

  .bg-403 {
    background-position: -190px -280px;
  }

  .bg-405 {
    background-position: -235px -280px;
  }

  .bg-406 {
    background-position: -280px -280px;
  }

  .bg-404 {
    background-position: -325px -10px;
  }

  .bg-406n {
    background-position: -325px -55px;
  }

  .bg-407 {
    background-position: -325px -100px;
  }

  .bg-407n {
    background-position: -325px -145px;
  }

  .bg-408 {
    background-position: -325px -190px;
  }

  .bg-409 {
    background-position: -325px -235px;
  }

  .bg-410 {
    background-position: -325px -280px;
  }

  .bg-499 {
    background-position: -10px -325px;
  }

  .bg-500 {
    background-position: -55px -325px;
  }

  .bg-501 {
    background-position: -100px -325px;
  }

  .bg-502 {
    background-position: -145px -325px;
  }

  .bg-503 {
    background-position: -190px -325px;
  }

  .bg-504 {
    background-position: -235px -325px;
  }

  .bg-507 {
    background-position: -280px -325px;
  }

  .bg-509 {
    background-position: -325px -325px;
  }

  .bg-508 {
    background-position: -370px -10px;
  }

  .bg-510 {
    background-position: -370px -55px;
  }

  .bg-511 {
    background-position: -370px -100px;
  }

  .bg-512 {
    background-position: -370px -145px;
  }

  .bg-513 {
    background-position: -370px -190px;
  }

  .bg-514 {
    background-position: -370px -235px;
  }

  .bg-515 {
    background-position: -370px -280px;
  }

  .bg-900 {
    background-position: -370px -325px;
  }

  .bg-901 {
    background-position: -10px -370px;
  }

  .bg-999 {
    background-position: -55px -370px;
  }

  .alarm-ul {
    display: none;
    position: absolute;
    width: 220px;
    margin: 0;
    top: 60px;
    max-height: 200px;
    overflow-y: auto;
    overflow-x: hidden;
    right: 0px;
    z-index: 1000;
    list-style-type: none;
    font-size: 15px;
    border-radius: 5px;
    padding: 0 10px;
    border: 1px solid #ddd;
    background: #fff;

    li {
      text-align: left;
      line-height: 35px;
      color: #000;
      width: 100%;
      // border-bottom: 1px solid #eee;
      display: flex;
      justify-content: flex-start;

      .alarm-text-inside {
        display: inline-block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 100%;
        position: relative;

        &::after {
          content: " ";
          position: absolute;
          left: 0;
          top: 5px;
          z-index: -1;
          width: 15px;
          height: 15px;
          border-radius: 50%;
        }

        &-error {
          &::after {
            background-color: rgba(255, 0, 0, 0.678);
          }
        }

        &-warn {
          &::after {
            background-color: rgba(255, 255, 0, 0.671);
          }
        }
      }

      .alarm-num-inside {
        display: inline-block;
      }

      &:hover {
        color: #243d91;
      }
    }
  }

  .time-show {
    line-height: 80px;
    font-size: 40px;
    font-weight: 300;
  }

  .date-address-show {
    padding-top: 23px;
    padding-left: 20px;
    cursor: pointer;

    p {
      margin: 0;
      text-align: right;
    }
  }

  .date-show {
    font-size: 12px;
  }

  .address-show {
    font-size: 17px;
  }

  .last-update-time {
    position: absolute;
    bottom: -5px;
    right: 0;
    color: #000;
    font-size: 12px;

    &::before {
      content: "上次更新时间： ";
    }
  }
}
</style>
